import {
  Component,
  OnInit,
  Input,
  ViewContainerRef,
  ViewChild,
  OnDestroy,
  HostBinding
} from '@angular/core';
import { BaseSetupService } from '../base-setup.service';
import { Subscription } from 'rxjs';
import { UserService } from '@nrwl/common-lib';

@Component({
  selector: 'nrwl-test-setup-tabs',
  templateUrl: './test-setup.template.html',
  styleUrls: ['./test-setup.component.style.scss']
})
export class TestSetupTabsComponent implements OnInit, OnDestroy {
  @ViewChild('contentPlaceholder1', { read: ViewContainerRef, static: true })
  contentRef1: ViewContainerRef;
  @ViewChild('contentPlaceholder2', { read: ViewContainerRef, static: true })
  contentRef2: ViewContainerRef;
  @ViewChild('contentPlaceholder3', { read: ViewContainerRef, static: true })
  contentRef3: ViewContainerRef;
  @ViewChild('contentPlaceholder4', { read: ViewContainerRef, static: true })
  contentRef4: ViewContainerRef;
  //eslint-disable-next-line
  @Input() parentObj: any;
  selectedTab = 1;
  setupService: BaseSetupService;
  templateName: string;
  subscription: Subscription;
  isDarkTheme = false;
  //eslint-disable-next-line
  constructor(
    private readonly baseService: BaseSetupService,
    private readonly userService: UserService
  ) {}

  ngOnInit() {
    this.setupService = this.parentObj.setupService;
    this.templateName = this.parentObj.templateName;
    this.subscription = this.baseService.templateNameEvent.subscribe(name => {
      if (name) {
        this.templateName = name;
      }
    });
    this.isDarkTheme = this.userService.getDefaultTheme() === 'dark';
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  toggleTabChange(index: number): void {
    this.selectedTab = index + 1;
    this.parentObj.toggleTabChange(index);
  }

  toggleFinish(): void {
    this.parentObj.toggleFinish();
  }
  downloadTestConfig(): void {
    this.parentObj.downloadTestConfig();
  }
  saveTestConfig(): void {
    this.parentObj.saveTestConfig();
  }
  openTemplates(): void {
    this.parentObj.openTemplates();
  }

  toggleClose(): void {
    this.setupService.dirtyFlag = true;
    this.parentObj.toggleClose();
  }

  hideCurrentTab(index: number): boolean {
    return this.selectedTab !== index;
  }

  getIconName(): string {
    return this.setupService.iconName;
  }

  isValidTab(index: number): boolean {
    if (this.setupService.tabs?.[index]) {
      return this.setupService.tabs[index].isValid();
    }
    return true;
  }
}
